import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from "react";

interface CompanyContextType {
  companyId: number;
  setCompanyId: Dispatch<SetStateAction<number>>;
}

const CompanyContext = createContext<CompanyContextType | null>(null);

function CompanyContextProvider({ children }: PropsWithChildren) {
  const [companyId, setCompanyId] = useState(0);

  return (
    <CompanyContext.Provider value={{ companyId, setCompanyId }}>
      {children}
    </CompanyContext.Provider>
  );
}

const useCompanyContext = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error("CompanyContext must be used with a provider");
  }

  return context;
};

export { CompanyContextProvider, useCompanyContext };
